import { errorDescription } from "@/utils/js-utils"
import CopyErrorButton from "./CopyErrorButton"
import Toast from "./Toast"

type DevErrorToastProps = {
  userMessage: string
  toastId: string | number
  error?: unknown
}

const DevErrorToast = ({ userMessage, toastId, error }: DevErrorToastProps) => {
  return (
    <Toast
      toastId={toastId}
      description={
        <span>
          {userMessage}
          {error !== undefined ? (
            <>
              <br />
              <span className="italic">{errorDescription(error)}</span>
            </>
          ) : null}
        </span>
      }
      action={<CopyErrorButton error={error ?? userMessage} />}
      variant="error"
    />
  )
}

export default DevErrorToast
